module.exports = __webpack_public_path__ + "static/media/ak_classes_book.6d2a3fab.png";